import { Component, OnInit } from '@angular/core';
import { ClientService } from '../../../services/client.service';

@Component({
  selector: 'app-pippedrive-integrations',
  templateUrl: './pippedrive-integrations.component.html',
  styleUrls: ['./pippedrive-integrations.component.scss']
})
export class PippedriveIntegrationsComponent implements OnInit {
  public data: any;
  public rowsOnPage: number = 10;
  public filterQuery: string = "";
  public sortBy: string = "";
  public sortOrder: string = "desc";

  constructor(private clientService: ClientService) { }

  ngOnInit() {
    this.getClients();
  }

  getClients() {
    const body = {
      id: JSON.parse(localStorage.getItem('user')).data.id
    }

    this.clientService.getByUser(body)
      .subscribe((data:any) => {
        this.data = data.data;
        console.log("pipes")
        console.log(this.data)
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/components/integrations/pippedrive-integrations/pippedrive-integrations.component.ts